import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { formatWrittenDayMonthYear } from "utilities";
import { getInvoiceDueDate } from "utilities/invoiceUtils";

interface Props {
  dueInDays: number;
  sendDate: moment.Moment
}

export const PaymentTermInvoiceV2 = (props: Props) => {
  const { dueInDays } = props;

  const dueDate = getInvoiceDueDate(props.sendDate, dueInDays);

  return <SmallDetails
    label={dueInDays > 1 ? `${dueInDays} ${RESX.DateTime.days}` : RESX.DateTime.YDay}
    subLabel={RESX.DateTime.Due + ": " + formatWrittenDayMonthYear(dueDate)}
  />
};

